<div class="spc-color-picker-button form-control pull-right" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <button
        #trigger
        type="button"
        class="spc-color-picker-button-area"
        [style.background]="colorValue()"
        [attr.aria-label]="ariaLabel()"
        aria-haspopup="dialog"
        [attr.aria-expanded]="isOpen()"
        (click)="toggle()"
    >
        <sp-transparent-icon [color]="colorValue()"></sp-transparent-icon>
    </button>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions()"
    cdkConnectedOverlayPanelClass="cp-v2-overlay-panel"
    (overlayOutsideClick)="onOutsideClick()"
    (detach)="close()"
>
    <div
        class="cp-v2-panel"
        role="dialog"
        [attr.aria-label]="ariaLabel()"
        cdkTrapFocus
        (keydown.escape)="onEscape($event)"
    >
        <sp-color-picker-dropdown
            [color]="colorValue()?.toLowerCase()"
            [colorsPreset]="colorsPreset()"
            [hideGradient]="hideGradient()"
            (setColorEvent)="setColorHandler($event)"
            (setColorPresetEvent)="setColorPresetHandler($event)"
        ></sp-color-picker-dropdown>
    </div>
</ng-template>
